import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .ThirdStep {
    width: 390px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
  :global(.TextFormField) {
    width: 100%;
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global``;
};

export { staticStyles, getDynamicStyles };
